import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { LoadingService } from '@services/loading.service';
import { Dialog } from '@angular/cdk/dialog';
import { IMaskDirective } from 'angular-imask';
import { ToastService } from '@services/toast.service';
import { FeedbackFormsService } from '@technokratos-public/services/feedback-forms.service';
import { SharedPublicFeedbackModule } from '@technokratos-public/components/modals/feedback/shared-public-feedback.module';
import { textMask } from '@utils/masks';
import { AgreementComponent } from '@technokratos-public/components/ui/agreement/agreement.component';
import { FormFieldInfoComponent } from '@ui/form-field-info/form-field-info.component';
import { FormFieldErrorComponent } from '@ui/form-field-error/form-field-error.component';
import { FormFieldTextCounterComponent } from '@ui/form-field-text-counter/form-field-text-counter.component';

@Component({
	standalone: true,
	selector: 'tk-media-form-modal',
	templateUrl: './media-form-modal.component.html',
	styleUrls: ['./media-form-modal.component.sass'],
	providers: [FeedbackFormsService, LoadingService],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		SharedPublicFeedbackModule,
		IMaskDirective,
		AgreementComponent,
		FormFieldInfoComponent,
		FormFieldErrorComponent,
		FormFieldTextCounterComponent,
	],
})
export class MediaFormModalComponent {
	public service = inject(FeedbackFormsService);
	public loading$ = inject(LoadingService);
	protected readonly textMask = textMask;
	private toast = inject(ToastService);
	private fb = inject(FormBuilder);
	private dialog = inject(Dialog);
	nameMaxLength = 80;
	fieldMaxLength = 100;
	themeMaxLength = 1000;
	form: FormGroup = this.fb.nonNullable.group({
		name: ['', [Validators.required, Validators.maxLength(this.nameMaxLength)]],
		media: ['', [Validators.required, Validators.maxLength(this.fieldMaxLength)]],
		contact: ['', [Validators.required, Validators.maxLength(this.fieldMaxLength)]],
		theme: ['', [Validators.required, Validators.maxLength(this.themeMaxLength)]],
		agreement: [false, Validators.requiredTrue]
	});

	constructor() {
		this.loading$.next(false);
	}

	onInput(event: Event, field: string) {
		this.form.get(field)?.setValue((event.target as HTMLInputElement).value);
	}

	submit(formRef: FormGroupDirective) {
	if (this.form.invalid) {
		return;
	}

	const formData = this.form.getRawValue();
	const requestData = {
		name: formData.name,
		media: formData.media,
		contact: formData.contact,
		theme: formData.theme
	};

	this.loading$.next(true);
	this.service.createMediaRequest(requestData).subscribe({
		next: () => {
			formRef.resetForm();
			this.loading$.next(false);
			this.dialog.closeAll();
			this.toast.success('Успешно отправлено');
		},
		error: () => {
			this.loading$.next(false);
			this.dialog.closeAll();
			this.toast.error('Ошибка');
		},
	});
}
}
